export default "__VITE_ASSET__Cm5klWFk__"